export default __webpack_public_path__ + "static/media/img-checklist.1b3f4678.svg";